module.exports = __webpack_public_path__ + "static/media/one_monkey_walk.cebad8a2.gif";